export default "__VITE_ASSET__5DKFNekj__"